import React from "react";

export function formatAsideMenuBadgeCount(value) {
	const n = Number(value) || 0;
	if (n > 99) return "99+";
	return String(n);
}

export function AsideMenuCountBadge({ count, variant = "default", title }) {
	const n = Number(count) || 0;
	if (n <= 0) return null;
	return (
		<span
			className={`aside-menu-badge aside-menu-badge--${variant}`}
			title={title || undefined}
			aria-label={title ? `${title}: ${n}` : undefined}
		>
			{formatAsideMenuBadgeCount(n)}
		</span>
	);
}

export function AsideMenuBadgeGroup({ children }) {
	const items = React.Children.toArray(children).filter(Boolean);
	if (!items.length) return null;
	return <span className="aside-menu-badges">{items}</span>;
}
